"use client";

import Image, { type ImageProps } from "next/image";

import { useDeploymentAssetSrc } from "~/app/_components/useDeploymentAssetSrc";
import { deploymentAssetUsesOptimizer } from "~/lib/deployment-assets";

type DeploymentAssetImageProps = Omit<ImageProps, "src"> & {
  filename: string;
  remoteUrl: string;
};

export function DeploymentAssetImage({
  filename,
  remoteUrl,
  alt,
  unoptimized,
  ...props
}: DeploymentAssetImageProps) {
  const src = useDeploymentAssetSrc(filename, remoteUrl);
  const resolvedUnoptimized =
    unoptimized ??
    (src.startsWith("blob:")
      ? true
      : src.startsWith("/assets/")
        ? false
        : !deploymentAssetUsesOptimizer(remoteUrl));

  return (
    <Image
      src={src}
      alt={alt}
      unoptimized={resolvedUnoptimized}
      {...props}
    />
  );
}
